/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { ItemVencido } from 'store/modules/my_history_store/types';
import ModalLicitacaoMyHistory from '../modal_licitacao_my_history';
import { Container } from './styles';

interface ListItensVencidosProps {
  itens: ItemVencido[];
}

const ListItensVencidos = ({ itens }: ListItensVencidosProps) => {
  const [showModal, setShowModal] = useState(false);
  const [licitacao, setLicitacao] = useState<any['itens'] | null>(null);

  useEffect(() => {
    if (licitacao) setShowModal(true);
  }, [licitacao]);

  return (
    <Container>
      <div className="table-responsive" style={{ maxHeight: '500px' }}>
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th scope="col">N.º CNL</th>
              <th scope="col">Edital/Órgão</th>
              <th scope="col">Cidade/Estado</th>
              <th scope="col">Item</th>
              <th scope="col">Qnt.</th>
              <th scope="col">Valor total</th>
            </tr>
          </thead>
          <tbody>
            {itens?.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center border-0 pb-0">
                  <div className="alert alert-secondary m-0" role="alert">
                    <p className="mb-0">Não foram encontrados resultados para este filtro.</p>
                  </div>
                </td>
              </tr>
            )}
            {itens?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <button
                      className="btn btn-link p-0"
                      type="button"
                      onClick={() => setLicitacao(item)}
                    >
                      {item?.bidding_id}
                    </button>
                  </td>
                  <td title={`${item?.edital} - ${item?.orgao}`}>
                    {item?.edital} - {item?.orgao}
                  </td>
                  <td>
                    {item?.cidade} - {item?.estado}
                  </td>
                  <td title={item?.descricao}>{item?.descricao}</td>
                  <td>{item?.quantidade}</td>
                  <td>
                    {item?.valor_final.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {showModal && licitacao && (
          <ModalLicitacaoMyHistory
            showModal={showModal}
            setShowModal={setShowModal}
            item={licitacao}
          />
        )}
      </div>
    </Container>
  );
};

export default ListItensVencidos;
